import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Custom `--text-*` steps declared in `src/index.css`'s `@theme` block.
 *
 * tailwind-merge ships a fixed list of font-size names and classifies any other
 * `text-<word>` as a *color*. An unregistered size step is therefore both
 * dropped by a later color class and unable to override `text-xs`/`text-sm` —
 * `cn("text-muted-foreground text-xs", "text-label")` yields
 * `"text-xs text-label"`, i.e. the wrong size in the wrong color. Every new
 * `--text-*` token must be added here as well as to `@theme`.
 */
const CUSTOM_FONT_SIZES = ["label", "mono", "sidebar-detail", "chat"];

const twMerge = extendTailwindMerge({
  extend: { classGroups: { "font-size": [{ text: CUSTOM_FONT_SIZES }] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
